import React, { useEffect, useState } from 'react';

import * as S from './styles';
import { CardsContainer, StyledText } from './styles';

import CardButton from '../../atoms/CardButton';

import Header from '../../molecules/Header';
import NavBar from '../../molecules/NavBar';
import MainContent from '../../molecules/MainContent';
import Footer from '../../molecules/Footer';
import { fireStore } from '../../../database/utils/firebase';

function AdminView() {
  // Native JavaScript date function
  const mounthNames = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Maio',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez'
  ];
  const myCurrentDate = new Date();

  const date = `${myCurrentDate.getDate()} ${
    mounthNames[myCurrentDate.getMonth()]
  } ${myCurrentDate.getFullYear()}`;

  const newCurrentDate = `Hoje,  ${date}`;
  const [usersCount, setUsersCount] = useState(0);
  const [addCount, setAddCount] = useState(0);
  const [chargesCount, setChargesCount] = useState(0);
  useEffect(() => {
    fireStore
      .collection('usuarios')
      .get()
      .then((res) => setUsersCount(res.docs.length));
    fireStore
      .collection('produtos')
      .get()
      .then((res) => setAddCount(res.docs.length));
    fireStore
      .collection('transactions')
      .get()
      .then((res) => setChargesCount(res.docs.length));
  }, []);

  return (
    <S.Container>
      <Header />
      <NavBar />
      <MainContent>
        {/* {useSelector(state => state.auth.user_logged_in) > 0 ? <Redirect to='/' /> : null} */}

        <div className="count-card-container"></div>
        {/* <S.CountCard>
            <div className="count-card-top">
              <div className="count-card-top-left">
                <i className="fas fa-users count-card-main-icon" />
                <p className="count-card-date">Hoje, 24 Mai 2021</p>

              </div>
              <a href="/adminclient">
                <i className="fas fa-cog half-opacity count-card-cog" />
              </a>
            </div>

            <div className="count-card-bot">
              <p className="count-stats">11</p>
              <span>Usuários</span>
            </div>
          </S.CountCard>

          <S.CountCard style={{ background: '#ffb615' }}>
            <div className="count-card-top">
              <div className="count-card-top-left">
                <i className="fas fa-bullhorn count-card-main-icon" />
                <p className="count-card-date">Hoje, 24 Mai 2021</p>
              </div>
              <a href="/AdminAds">
                <i className="fas fa-cog half-opacity count-card-cog" />
              </a>
            </div>

            <div className="count-card-bot">
              <p className="count-stats">14</p>
              <span>Anúncios</span>
            </div>
          </S.CountCard>

          <S.CountCard style={{ background: '#ce1720' }}>
            <div className="count-card-top">
              <div className="count-card-top-left">
                <i className="fas fa-chalkboard-teacher count-card-main-icon" />
                <p className="count-card-date">Hoje, 24 Mai 2021</p>
              </div>
              <i className="fas fa-cog half-opacity count-card-cog" />
            </div>

            <div className="count-card-bot">
              <p className="count-stats">0</p>
              <span>Transações</span>
            </div>
          </S.CountCard> */}

        <CardsContainer>
          <CardButton href="/admin/users" background="#002666">
            <div>
              <i className="fas fa-users count-card-main-icon" />
              <StyledText left>{newCurrentDate}</StyledText>
              {/* <i className="fas fa-caret-down half-opacity count-card-caret-down" /> */}
              {/* <i className="fas fa-cog half-opacity count-card-cog" /> */}
            </div>

            <div>
              <StyledText size bold>
                {usersCount}
              </StyledText>
              <StyledText left>Usuários</StyledText>
            </div>
          </CardButton>

          <CardButton href="/admin/ads" background="#ffb615">
            <div>
              <i className="fas fa-bullhorn count-card-main-icon" />
              <StyledText left>{newCurrentDate}</StyledText>
              {/* <i className="fas fa-caret-down half-opacity count-card-caret-down" /> */}
              {/* <i className="fas fa-cog half-opacity count-card-cog" /> */}
            </div>

            <div>
              <StyledText size bold>
                {addCount}
              </StyledText>
              <StyledText left>Anúncios</StyledText>
            </div>
          </CardButton>

          <CardButton href="/admin/charges" background="#ce1720">
            <div>
              <i className="fas fa-chalkboard-teacher count-card-main-icon" />
              <StyledText left>{newCurrentDate}</StyledText>
              {/* <i className="fas fa-caret-down half-opacity count-card-caret-down" /> */}
              {/* <i className="fas fa-cog half-opacity count-card-cog" /> */}
            </div>

            <div>
              <StyledText size bold>
                {chargesCount}
              </StyledText>
              <StyledText left>Transações</StyledText>
            </div>
          </CardButton>
        </CardsContainer>
        <div className="count-card-container"></div>
        {/* </div> */}
        {/* <S.TableContainer>
          <div className="table-title-container">
            <h1>Usuários Ativos</h1>
            <span>
              <i className="fas fa-search table-glass"> </i>
              Encontrar usuarios
            </span>
          </div>
          <table>
            <th>Anunciante</th>
            <th>Nome</th>
            <th>E-mail</th>
            <th>Favoritos</th>
            <th>Último Acesso</th>
            <th>Entrada</th>

            <tr>
              <td>
                <text>Sim</text>
              </td>
              <td>Denise Ann</td>
              <td>denise@gmail.com</td>
              <td>0</td>
              <td>9:23 AM</td>
              <td>
                <i className="fab fa-internet-explorer" /> 8/27/2015
              </td>
            </tr>

            <tr>
              <td>
                <text>Sim</text>
              </td>
              <td>Denise Ann</td>
              <td>denise@gmail.com</td>
              <td>0</td>
              <td>9:23 AM</td>
              <td>
                <i className="fab fa-internet-explorer" /> 8/27/2015
              </td>
            </tr>

            <tr>
              <td>
                <text className="red">Não</text>
              </td>
              <td>Denise Ann</td>
              <td>denise@gmail.com</td>
              <td>0</td>
              <td>9:23 AM</td>
              <td>
                <i className="far fa-envelope" /> 8/27/2015
              </td>
            </tr>

            <tr>
              <td>
                <text>Sim</text>
              </td>
              <td>Denise Ann</td>
              <td>denise@gmail.com</td>
              <td>0</td>
              <td>9:23 AM</td>
              <td>
                <i className="far fa-envelope" /> 8/27/2015
              </td>
            </tr>

            <tr>
              <td>
                <text className="red">Não</text>
              </td>
              <td>Denise Ann</td>
              <td>denise@gmail.com</td>
              <td>0</td>
              <td>9:23 AM</td>
              <td>
                <i className="fab fa-internet-explorer" /> 8/27/2015
              </td>
            </tr>

            <tr>
              <td>
                <text>Sim</text>
              </td>
              <td>Denise Ann</td>
              <td>denise@gmail.com</td>
              <td>0</td>
              <td>9:23 AM</td>
              <td>
                <i className="fab fa-internet-explorer" /> 8/27/2015
              </td>
            </tr>

            <tr>
              <td>
                <text>Sim</text>
              </td>
              <td>Denise Ann</td>
              <td>denise@gmail.com</td>
              <td>0</td>
              <td>9:23 AM</td>
              <td>
                <i className="far fa-envelope" /> 8/27/2015
              </td>
            </tr>

            <tr>
              <td>
                <text>Sim</text>
              </td>
              <td>Denise Ann</td>
              <td>denise@gmail.com</td>
              <td>0</td>
              <td>9:23 AM</td>
              <td>
                <i className="fab fa-internet-explorer" /> 8/27/2015
              </td>
            </tr>
          </table>
        </S.TableContainer> */}
      </MainContent>
      <Footer />
    </S.Container>
  );
}

export default AdminView;
